import React, { ReactNode } from 'react';
import { LayoutInternal } from '@/layout';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { TitleFeatured } from '@/components/typography';
import { CardBody, CardFeatured, CardFooter, CardTitle } from '@/components/card';
import CardImage from '@/components/card/CardImage/CardImage';
import { urlPacotes } from '@/config/url';
import Link from '@/providers/Link';
import { Button } from '@/components/button';
import { GridContainer } from './ViagensList.styles';
import FilterListItems from '@/features/pacote/components/FilterListItems/FilterListItems';

export interface ViagensListProps {
  data: ViagemDataType;
  children?: ReactNode;
}

const ViagensList = ({ data, children, ...props }: ViagensListProps) => {
  const { travelType, destinos } = data;
  const breadcrumbs: BreadcrumbType = [
    { path: '/viagens', text: 'Viagens' },
    { path: travelType.slug, text: travelType.title },
  ];

  const parseLink = (slug: string, travelTypeSlug: string) => {
    return urlPacotes(slug, travelTypeSlug);
  };

  return (
    <LayoutInternal breadcrumbs={breadcrumbs} cover={travelType.cover}>
      <WhitePaper col={12}>
        <TitleFeatured as="h1" title={travelType.title} description={travelType.description} />
      </WhitePaper>
      <WhitePaper col={12}>
        <FilterListItems placeholder="Filtrar Destinos" initialData={destinos}>
          {({ data }) => (
            <GridContainer>
              {data.map(({ slug, title, excerpt, image }, index) => (
                <CardFeatured key={`${slug}-${index}`}>
                  <CardImage image={image} href={parseLink(slug, travelType.slug)} priority={index <= 1} />
                  <CardTitle as="h2" textCase="uppercase">
                    <Link href={parseLink(slug, travelType.slug)}>{title}</Link>
                  </CardTitle>
                  <CardBody>{excerpt}</CardBody>
                  <CardFooter>
                    <Button href={parseLink(slug, travelType.slug)} block arrow>
                      {slug === 'crie-seu-roteiro' ? 'Crie Seu Roteiro' : `Viagens ${title}`}
                    </Button>
                  </CardFooter>
                </CardFeatured>
              ))}
            </GridContainer>
          )}
        </FilterListItems>
      </WhitePaper>
    </LayoutInternal>
  );
};

export default ViagensList;
